var _path, _path2, _path3, _rect, _path4, _rect2, _rect3, _circle, _rect4, _circle2, _rect5, _circle3, _circle4, _path5, _path6, _path7, _circle5, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 340 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95 200h150",
    stroke: "#627A92",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 30h335",
    stroke: "#E0E4E9",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145 199v-16",
    stroke: "#627A92",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 338,
    height: 181,
    rx: 7,
    stroke: "#627A92",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M195 199v-16",
    stroke: "#627A92",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 8,
    width: 16,
    height: 16,
    rx: 2,
    fill: "#E0E4E9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 11,
    width: 34,
    height: 9,
    rx: 4.5,
    fill: "#E0E4E9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 15.5,
    r: 4.5,
    fill: "#E0E4E9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 11,
    width: 34,
    height: 9,
    rx: 4.5,
    fill: "#E0E4E9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.5,
    cy: 15.5,
    r: 4.5,
    fill: "#E0E4E9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 197,
    y: 11,
    width: 34,
    height: 9,
    rx: 4.5,
    fill: "#E0E4E9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 188.5,
    cy: 15.5,
    r: 4.5,
    fill: "#E0E4E9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 98,
    r: 28,
    stroke: "#627A92",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M191 99.96h-16.65c.9.458-.45-3.202-3.15-3.202 0-11.623-.45-14.64 0-18.758 10.935 0 19.8 10.337 19.8 21.96Z",
    fill: "#E0E4E9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.00005 1 -.99897 .0454 169.91 76.791)",
    stroke: "#627A92",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M1-1h18.4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M175 100h18M171 65v4",
    stroke: "#627A92",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 100,
    r: 3.5,
    stroke: "#627A92"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M178 64h-14",
    stroke: "#627A92",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorInactive);
export default __webpack_public_path__ + "static/media/errorInactive.5c9b4ceefd8dff68e952286f181fd8be.svg";
export { ForwardRef as ReactComponent };